import React from "react";
import { useSettings } from "_contexts/useSettings";
import "./Headline.scss";

function Headline(props) {
  const { settings } = useSettings();
  const newProps = { ...props };
  newProps.className = "pp-headline " + (newProps.className || "");

  const style = {
    fontFamily: settings?.primary_font || "Gambarino",
  };

  return (
    <h1 {...newProps} style={style}>
      {newProps.children}
    </h1>
  );
}

export default Headline;
